<template>
  <main id="container" class="page-container bg-wave5">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="이벤트" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-giftCertificate">
      <div class="container">
        <div class="page-sub-header">
          <!-- <h3 class="page-sub-title">
            <span class="green">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3> -->
        </div>
      </div>
      <div class="page-tab-container">
        <div class="container tab-buttons">
          <!-- <router-link to="eatingOut" class="tab-button">외식 활성화</router-link>
          			<router-link to="dineOut" class="tab-button">오늘 식사 한 끼, 밖에서 먹어요</router-link>
					<router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button is-active">찜하기</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link> -->
          <!-- <router-link to="delivery" class="tab-button"
            >공공배달앱 이용후기</router-link
          >
          <router-link to="giftCertificate" class="tab-button"
            >지역사랑상품권 이벤트</router-link
          > -->
          <!-- <router-link to="winPage" class="tab-button is-active"
          <router-link to="winPage" class="tab-button is-active"
            >이벤트 당첨 결과</router-link
          > -->
          <!-- <router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link> -->
        </div>
      </div>
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                  src="@/assets/img/event/EventWinPage1204.png"
                  alt="베스트리뷰 보기"
                />
              </div>
            </div>            
          </div>          
        </div>
      </div>
    </div>
    <event-terms-modal
      :visible="visibleModal"
      @closeModal="visibleModal = false"
      @agreeModal="prvcMktAgrePopup"
    />
  </main>
</template>
<script>
import PageHeader from "@/components/content/PageHeader";
import EventTermsModal from "@/components/content/EventTermsModal";
import { mapGetters } from "vuex";
export default {
  name: "EventWinPage",
  components: { PageHeader, EventTermsModal },
  data: () => ({}),
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
  },
  watch: {},
  async created() {
  },
  mounted() {
  },
  methods: {    
    clickLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
